import { NoValue, PvmoUserRight, UserRightInfos } from '@tribeauto/ngx-mobilite-material';

export const isAdmin = (userRightList: UserRightInfos[] | NoValue): boolean => {
  return !!userRightList?.some(userRight =>
    [
      PvmoUserRight.PVMO_ADMIN_USER_CREATION,
      PvmoUserRight.PVMO_ADMIN_USER_MODIFICATION,
      PvmoUserRight.PVMO_ADMIN_USER_VALIDATION,
      PvmoUserRight.PVMO_ADMIN_USER_DEACTIVATION
    ].includes(userRight.name as PvmoUserRight)
  );
};
